import React from 'react'
import aboutContactImage from '../../img/home-banner-package.jpg'; 
import HeritageDetail from './HeritageDetail';
import Footer from '../home-page/Footer';
export default function Heritage() {
  return (
    <div>
             <div className="activity-hero-section">
             <img src={aboutContactImage} alt="About Us" className="activity-hero-image" />
            <div className="about-hero-overlay"></div>
            <div className="about-hero-content">
              <h1>Package</h1>
              <div className="breadcrumb">
                <span>Package</span> &gt; <span>Heritage Walks and Tours</span>
              </div>
            </div>
          </div>
          <HeritageDetail/>
        <Footer/>
    </div>
  )
}
